import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import PasswordModal from '@/components/container/modal/password/PasswordModal'

interface PasswordModalState {}

const defaultValue = {}

export const PasswordModalContext = createModalContext<PasswordModalState>(defaultValue)

const PasswordModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<PasswordModalState>(defaultValue)
  return (
    <PasswordModalContext.Provider value={state}>
      {children}
      <PasswordModal />
    </PasswordModalContext.Provider>
  )
}

export default PasswordModalProvider
